import React from 'react';

const AiSearchIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M10.4873 2.4873C6.06903 2.4873 2.4873 6.06903 2.4873 10.4873C2.48757 14.9054 6.06919 18.4873 10.4873 18.4873C14.4847 18.4871 17.7971 15.5545 18.3916 11.7236H19.4004C19.1507 13.5401 18.3573 15.182 17.1924 16.4844L22.3506 21.6494L21.6426 22.3574L16.4854 17.1924C14.8936 18.6182 12.7928 19.4872 10.4873 19.4873C5.5169 19.4873 1.48659 15.4576 1.48633 10.4873C1.48633 5.51674 5.51674 1.48633 10.4873 1.48633V2.4873Z"
      fill="currentColor"
    />
    <path
      d="M9.40909 6.175C12.7479 6.175 15.4545 3.41036 15.4545 0C15.4545 3.41036 18.1612 6.175 21.5 6.175C18.1612 6.175 15.4545 8.93964 15.4545 12.35C15.4545 8.93964 12.7479 6.175 9.40909 6.175Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M7.5 10.725C8.73009 10.725 9.72727 9.70645 9.72727 8.45C9.72727 9.70645 10.7245 10.725 11.9545 10.725C10.7245 10.725 9.72727 11.7436 9.72727 13C9.72727 11.7436 8.73009 10.725 7.5 10.725Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);

export default AiSearchIcon;
